import React from "react";
import PropTypes from "prop-types";
import StarRating from "../../utilities/components/StarRating";
import { Quote, CheckCircle } from "lucide-react";

const ReviewCard = ({ review }) => {
  // Fallback avatar if user doesn't have one
  const avatarUrl =
    review.user?.profilePictureUrl || "assets/images/icon-profile.png";
  const firstName = review.user?.firstName || "Guest";
  const lastName = review.user?.lastName || "";
  const fullName = `${firstName} ${lastName}`.trim();

  return (
    <div className="group relative bg-white dark:bg-slate-800 p-6 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 border border-slate-100 dark:border-slate-700 h-full flex flex-col">
      {/* Decorative Quote Icon */}
      <div className="absolute top-6 right-6 text-slate-100 dark:text-slate-700">
        <Quote size={40} fill="currentColor" />
      </div>

      {/* User Header */}
      <div className="flex items-center gap-4 mb-4 relative z-10">
        <img
          src={avatarUrl}
          alt={fullName}
          className="w-12 h-12 rounded-full object-cover ring-2 ring-slate-100 dark:ring-slate-700"
        />
        <div>
          <h4 className="font-bold text-slate-900 dark:text-white text-base flex items-center gap-1">
            {fullName}
            <CheckCircle
              size={14}
              className="text-blue-500"
              fill="currentColor"
              stroke="white"
            />
          </h4>
          <div className="flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400">
            <span>Verified Guest</span>
          </div>
        </div>
      </div>

      {/* Rating */}
      <div className="mb-3">
        <StarRating rating={review.rating} size={4} />
      </div>

      {/* Review Title & Body */}
      <h3 className="font-serif font-bold text-lg text-slate-800 dark:text-slate-100 mb-2">
        {review.title}
      </h3>
      <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed italic mb-4 flex-grow">
        "{review.comment}"
      </p>

      {/* Date Footer */}
      <div className="mt-auto pt-4 border-t border-slate-100 dark:border-slate-700 text-xs text-slate-400 font-medium uppercase tracking-wider">
        {new Date(review.postedDate).toLocaleDateString(undefined, {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </div>
    </div>
  );
};

ReviewCard.propTypes = {
  review: PropTypes.object.isRequired,
};

export default ReviewCard;
